export const OTHER_PREFIX_VALUE = "Other";
export const PREFER_NOT_TO_SAY_VALUE = "Prefer not to say";

export const PREFIX_OPTIONS = [
  { id: 0, label: "Mr.", value: "Mr." },
  { id: 1, label: "Mrs.", value: "Mrs." },
  { id: 2, label: "Ms.", value: "Ms." },
  { id: 3, label: "Dr.", value: "Dr." },
  { id: 4, label: "Prof.", value: "Prof." },
  { id: 5, label: "Rev.", value: "Rev." },
  { id: 6, label: "Hon.", value: "Hon." },
  { id: 7, label: "Sir.", value: "Sir." },
  { id: 8, label: "Senator.", value: "Senator." },
  { id: 9, label: "Other (Type)", value: OTHER_PREFIX_VALUE },
  { id: 10, label: PREFER_NOT_TO_SAY_VALUE, value: "" },
];
